<div class="creator-container">
    <div class="header">
        <div class="header-actions">
            <h3>{{heading}}</h3>
            <button mat-icon-button (click)="openAddHistoryDialog()" matTooltip="Add new operation" *ngIf="!hideActions"
                color="primary">
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <mat-checkbox *ngIf="!hideActions && !hideCheckbox" [(ngModel)]="noHistory" name="noHistory" class="checkbox"
            (change)="toggleNoHistory()">No History / Operations</mat-checkbox>
    </div>

    <ng-container *ngIf="!noHistory || hideActions">
        <!-- Common Conditions Checklist -->
        <div class="common-conditions-section" *ngIf="!hideActions">
            <button mat-button (click)="toggleCommonConditions()" class="toggle-conditions-btn"
                [class.expanded]="showCommonConditions">
                <mat-icon>{{ showCommonConditions ? 'expand_less' : 'expand_more' }}</mat-icon>
                Common Medical Conditions
            </button>

            <div class="conditions-checklist" *ngIf="showCommonConditions">
                <div class="conditions-grid">
                    <div *ngFor="let condition of commonConditions; trackBy: trackByCondition" class="condition-item">
                        <mat-checkbox [(ngModel)]="condition.checked" (change)="onConditionToggle(condition)"
                            class="condition-checkbox">
                        </mat-checkbox>

                        <div class="condition-content">
                            <div class="condition-text">
                                <div class="condition-name">{{ condition.name }}</div>
                                <div class="condition-hint hint" *ngIf="condition.hint">{{ condition.hint }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mat-form-field class="full-width" appearance="outline" (click)="openAddHistoryDialog()">
            <mat-label>Medical History/Operations</mat-label>
            <mat-chip-grid #chipGrid>
                <mat-chip-row *ngFor="let item of history; trackBy: trackByHistoryItem"
                    (click)="$event.stopPropagation()" [appTouchEdit]="!hideActions" (dblclick)="hideActions ? {} : editHistory(item)"
                    [matTooltip]="getTooltipText(item)">
                    {{item.surgery}}
                    <mat-icon *ngIf="reported(item)" class="patient-reported-mark" aria-label="Patient reported">person</mat-icon>
                    <button matChipRemove (click)="removeHistory(item)" *ngIf="!hideActions">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </mat-chip-grid>
            <input [matChipInputFor]="chipGrid" disabled />
            <mat-hint *ngIf="!hideActions">Double click or tap and hold an item to edit the information</mat-hint>
        </mat-form-field>

    </ng-container>

    <ng-template #addHistoryDialog>
        <h1 mat-dialog-title>Medical History/Operation Details</h1>
        <div mat-dialog-content>
            <div class="p-t-20">

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Condition/Surgery</mat-label>
                    <input matInput [(ngModel)]="editingHistory.surgery" placeholder="Condition/Surgery" type="text"
                        required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Year</mat-label>
                    <input matInput [(ngModel)]="editingHistory.year" placeholder="Year" type="text">
                </mat-form-field>
            </div>

        </div>
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" (click)="saveHistory()"
                [disabled]="!editingHistory.surgery">Save</button>
        </div>

    </ng-template>
</div>